import React from 'react';
import { COLORS } from '../utils/constants.js';

export default function Badge({ children, color = COLORS.accent, bg }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 9999,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.5,
        color,
        background: bg || `${color}22`,
        textTransform: 'uppercase',
      }}
    >
      {children}
    </span>
  );
}
